import { render, staticRenderFns } from "./PersonalHome.vue?vue&type=template&id=5e70fa01&scoped=true&"
import script from "./PersonalHome.vue?vue&type=script&lang=js&"
export * from "./PersonalHome.vue?vue&type=script&lang=js&"
import style0 from "./PersonalHome.vue?vue&type=style&index=0&id=5e70fa01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70fa01",
  null
  
)

export default component.exports